import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import HsForms from "../hs-forms";

export const SimpleForm = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

    const hasValidTitle = sc.form_title?.richText?.some(
        (block) => block.text?.trim() !== ""
    );

    return (
        <section className={"bg-" + (bg) + " " + (sc.theme) + " " + (space)}>
            <div className="wrapper">
                
                <div className="bg-white p-12 md:p-20 w-full md:w-3/4 m-auto hs-center rounded-3xl shadow-2xl">
                {hasValidTitle && (
                    <div className={"text-2xl mb-4 text-" + sc.theme}>
                        <PrismicRichText field={sc.form_title.richText} />
                    </div>
                )}
                <PrismicRichText field={sc.form_content.richText} />
                    <HsForms formId={sc.form_id} /></div>
                
            </div>
        </section>
    );
}

